// EditableCalendar.js
import React, { useState, useEffect } from "react";
import "./EditableCalendar.scss";

const EditableCalendar = ({
  leaveId,
  onChange,
  readOnly = false,
  initialNotes = {},
}) => {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [notes, setNotes] = useState(initialNotes); // <-- pré-remplir

  const [holidays, setHolidays] = useState([]);

  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDay = new Date(currentYear, currentMonth, 1).getDay();
  const adjustedFirstDay = (firstDay + 6) % 7;

  const formatDateKey = (day) =>
    `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;

  // Mettre à jour le state si initialNotes change
  useEffect(() => {
    setNotes(initialNotes);
  }, [initialNotes]);

  const handleInputChange = (day, value) => {
    if (readOnly) return;
    if (
      value === "" ||
      value === "0" ||
      value === "0." ||
      value === "0.5" ||
      value === "1"
    ) {
      const key = formatDateKey(day);
      const updatedNotes = { ...notes, [key]: value };
      setNotes(updatedNotes);
      if (onChange) onChange(leaveId, updatedNotes);
    }
  };

  const getNote = (day) => notes[formatDateKey(day)] || "";

  const monthNames = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  const handlePrevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else setCurrentMonth(currentMonth - 1);
  };

  const handleNextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else setCurrentMonth(currentMonth + 1);
  };

  useEffect(() => {
    const fetchHolidays = async () => {
      try {
        const response = await fetch(
          `https://date.nager.at/api/v3/PublicHolidays/${currentYear}/FR`
        );
        const data = await response.json();
        setHolidays(data);
      } catch (error) {
        console.error("Erreur chargement jours fériés :", error);
      }
    };
    fetchHolidays();
  }, [currentYear]);

  const isHoliday = (day) => {
    const dateStr = formatDateKey(day);
    return holidays.some((h) => h.date === dateStr);
  };

  return (
    <div className="calendar-container">
      <div className="calendar-header-bar">
        <button onClick={handlePrevMonth}>◀</button>
        <h3>
          {monthNames[currentMonth]} {currentYear}
        </h3>
        <button onClick={handleNextMonth}>▶</button>
      </div>

      <div className="calendar-grid">
        {["LU", "MA", "ME", "JE", "VE", "SA", "DI"].map((d) => (
          <div key={d} className="calendar-header">
            {d}
          </div>
        ))}

        {[...Array(adjustedFirstDay)].map((_, i) => (
          <div key={`empty-${i}`} className="calendar-day empty"></div>
        ))}

        {[...Array(daysInMonth)].map((_, i) => {
          const day = i + 1;
          const weekday = new Date(currentYear, currentMonth, day).getDay();
          const isWeekend = weekday === 0 || weekday === 6;
          const holiday = isHoliday(day);

          return (
            <div
              key={day}
              className={`calendar-day ${isWeekend ? "weekend" : ""} ${
                holiday ? "holiday" : ""
              }`}>
              <div className="day-number">{day}</div>
              <input
                type="text"
                value={getNote(day)}
                onChange={(e) => handleInputChange(day, e.target.value)}
                placeholder=""
                disabled={readOnly || isWeekend || holiday}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EditableCalendar;
